
import API from "@/models/API";

export let sleepUntil = (boolFn = () => false, limit = 3000) => {
    let start = new Date();
    const loop = done =>
        boolFn() || new Date() - start > limit
            ? done()
            : setTimeout(() => loop(done), 500);
    return new Promise(loop);
};

export let getBase64ImageFromUrl = async imageUrl => {
    try {
        let response = await API.post(
            `/companies/${localStorage.getItem("storeId")}/campaigns/image-to-b64`,
            {url: imageUrl}
        );
    
        let base64 = response.data.data.b64
        return base64
       
    } catch (error) {
        console.error("Error fetching or converting the image:", error);
        throw error;
    }
};

export const onlyIntegerNumbers = (event) => {
    const key = event.key;
    if (!/^\d+$/.test(key)) {
        event.preventDefault();
    }
};

export let localizeDate = (date, short) => {
    return date
        ? new Date(date).toLocaleString(this.locale, {
              weekday: short ? undefined : "long",
              year: "numeric",
              month: short ? "numeric" : "long",
              day: "numeric"
          })
        : "-";
};
